import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Col,
  FlexboxGrid,
  Form,
  Input,
  InputNumber,
  InputPicker,
  Message,
  Modal,
  Schema,
  SelectPicker,
  Stack,
  toaster
} from 'rsuite';
import ImageIcon from '@rsuite/icons/Image';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import { validateEmail2 } from '@/functions';

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const Category = ['Admin', 'Staff'].map(item => ({ label: item, value: item }));
const { StringType } = Schema.Types;
const model = Schema.Model({
  password: StringType().isRequired('This field is required.'),
  verifyPassword: StringType()
    .addRule((value, data) => {
      if (value !== data.password) {
        return false;
      }

      return true;
    }, 'The passwords do not match')
    .isRequired('This field is required.')
});
const TextField = React.forwardRef((props, ref) => {
  const { name, label, accepter, ...rest } = props;
  return (
    <Form.Group controlId={`${name}-4`} ref={ref}>
      <Form.ControlLabel>{label} </Form.ControlLabel>
      <Form.Control name={name} accepter={accepter} {...rest} />
    </Form.Group>
  );
});

const UserReg = ({ openuser, handleCloseUser }) => {
  const [meta, setMeta] = useState<MetaData>();
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const response = await fetch(
      `${globalIP}/api/user-details?populate=*&pagination[page]=1&sort[0]=id:desc`
    );
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/user-details?populate=*&pagination[page]=${page}&sort[0]=id`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setMeta(json.meta);
  };
  const formRef = React.useRef();
  const [formValue, setFormValue] = useState({
    password: '',
    verifyPassword: ''
  });
  const [desgindata, setDesgindata] = useState([]);
  useEffect(() => {
    fetchDataDesign();
  }, []);
  const fetchDataDesign = async () => {
    try {
      const response = await fetch(`${globalIP}/api/designations?&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${globalIP}/api/designations?&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.Designation,
          value: item.attributes.Designation
        }));
        allData.push(...processedData);
      }
      setDesgindata(allData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [dataadd, setDataadd] = useState({
    Company_Name: '',
    Full_Name: '',
    Username: '',
    Category: '',
    Email_Id: '',
    Made_By: 'Shantanu',
    MobileNo: '0',
    Password: '',
    Designation: '',
    UserCode: ''
  });
  const handleInputChange = (inputName, value) => {
    setDataadd(prevData => ({
      ...prevData,
      [inputName]:
        inputName === 'MobileNo'
          ? value?.toString().trim() || '0' // Default to '0' if empty
          : inputName === 'Username'
          ? value.trim()
          : value !== null
          ? value
          : ''
    }));
  };
  const [imageFile, setImageFile] = useState(null);
  const [auth, setAuth] = useState(false);
  const [data1, setData1] = React.useState([]);
  useEffect(() => {
    fetchDatac();
  }, []);
  const fetchDatac = async () => {
    try {
      const response = await fetch(`${globalIP}/api/company-details?populate=*`);
      const json = await response.json();
      const processedData = json.data.map(item => ({
        label: item.attributes.cmpnm,
        value: item.attributes.cmpcd
      }));
      setData1(processedData);
      setAuth(json.data[0].attributes.Authorised);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = event => {
    const file = event.target.files[0];
    console.log('file :', file);

    if (file) {
      // Validate the file type
      const validTypes = ['image/jpeg', 'image/jpg'];
      if (!validTypes.includes(file.type)) {
        alert('Please upload a file in JPG or JPEG format.');
        return;
      }
      // Create a blob URL
      const blobFile = URL.createObjectURL(file);
      setImageFile(blobFile);
      console.log('blob file : ', blobFile);

      // Call the handleImageUpload function
      handleImageUpload([{ file }]);
    }
  };
  const handleImageUpload = async fileList => {
    console.log('blob file : ', fileList);
    setDataadd({
      ...dataadd,
      UserImage: fileList[0].file
    });
  };
  const generateNextUserCode = () => {
    const nextCode = meta?.pagination?.total + 1;
    return `USR-${nextCode.toString().padStart(3, '0')}`;
  };
  let nextUserCode = generateNextUserCode();
  const message = (
    <Message showIcon type="success" closable>
      Saved Successfully
    </Message>
  );
  const submit = async e => {
    const { data: userData } = await axios.get(
      `${globalIP}/api/user-details?populate=*&filters[Username][$eqi]=${dataadd.Username}`
    );
    const usernameExists = userData.data.some(
      user => user.attributes.Username.toLowerCase() === dataadd.Username.toLowerCase()
    );
    // Step 1: Fetch company info for selected company
    const companyResponse = await fetch(`${globalIP}/api/company-details?populate=*`);
    const companyJson = await companyResponse.json();
    const selectedCompany = companyJson.data.find(
      comp =>
        comp.attributes.cmpcd.trim().toLowerCase() === dataadd.Company_Name.trim().toLowerCase()
    );

    if (!selectedCompany) {
      toaster.push(
        <Message showIcon type="error">
          Company not found
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }

    const userLimit = selectedCompany.attributes.UserLimit;

    // Step 2: Count existing users for this company
    const userRes = await fetch(`${globalIP}/api/user-details?populate=*`);
    const userJson = await userRes.json();
    const companyUsers = userJson.data.filter(
      user =>
        user.attributes.Company_Name.trim().toLowerCase() ===
        dataadd.Company_Name.trim().toLowerCase()
    );

    if (companyUsers.length >= userLimit) {
      toaster.push(
        <Message showIcon type="error">
          User limit reached for this company. Max allowed: {userLimit}
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else if (dataadd.Full_Name.trim() === '') {
      toaster.push(
        <Message showIcon type="error">
          Enter Full Name
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else if (dataadd.Category === '' || dataadd.Category === null) {
      toaster.push(
        <Message showIcon type="error">
          Enter Category
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else if (dataadd.Username.trim() === '') {
      toaster.push(
        <Message showIcon type="error">
          Enter Username
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else if (usernameExists) {
      toaster.push(
        <Message showIcon type="error">
          Username already taken. Please choose a different one.
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else if (dataadd.Password.trim() === '') {
      toaster.push(
        <Message showIcon type="error">
          Enter Password
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else if (dataadd.Password !== formValue.verifyPassword) {
      toaster.push(
        <Message showIcon type="error">
          Please Confirm Password
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else if (dataadd.Company_Name === '') {
      toaster.push(
        <Message showIcon type="error">
          Enter Company Name
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }

    if (dataadd.Email_Id) {
      if (dataadd.Email_Id.trim() == '') {
        toaster.push(
          <Message showIcon type="error">
            Email is required
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (!validateEmail2(dataadd.Email_Id.trim())) {
        toaster.push(
          <Message showIcon type="error">
            Please check our Email.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
    }
    e.preventDefault();
    nextUserCode = generateNextUserCode();
    const nextCUCode = nextUserCode;
    const formData = new FormData();
    formData.append('files.UserImage', dataadd.UserImage);
    const condition = dataadd.Category === 'Admin' ? true : false;
    let authorizedStatus;
    if (!auth) {
      authorizedStatus = true;
    } else {
      authorizedStatus = dataadd.Category === 'Admin' ? true : false;
    }
    formData.append(
      'data',
      JSON.stringify({
        ...dataadd,
        UserCode: nextCUCode,
        MProduct: condition,
        MCatalogue: condition,
        MCollection: condition,
        MQuotation: condition,
        MBuyer: condition,
        MEmarketing: condition,
        PMaster: condition,
        MSTCategory: condition,
        MSTPType: condition,
        MSTCollection: condition,
        MSTFinish: condition,
        MSTColor: condition,
        MSTHSN: condition,
        MSTShape: condition,
        MSTPTechnique: condition,
        MSTProcess: condition,
        MSTMaterial: condition,
        PRDView: condition,
        PRDAdd: condition,
        PRDManage: condition,
        PRDEdit: condition,
        PRDDelete: condition,
        PRDpicdwnld: condition,
        CATcreate: condition,
        CATupdate: condition,
        CATaccessPPT: condition,
        CATLinkSecurity: condition,
        CATShwPrice: condition,
        CATCustomizeTab: condition,
        CATModifySts: condition,
        CATBuyerAct: condition,
        CATControlSet: condition,
        CATDelete: condition,
        MSpaceV: condition,
        MFair: condition,
        MEnquiry: condition,
        Authorised: authorizedStatus
      })
    );

    fetch(`${globalIP}/api/user-details`, {
      method: 'POST',
      body: formData
    })
      // .then(response => fetchData())
      .then(Response => Response.json())
      .then(data => {
        console.log(data);
        fetchData();
      })
      .catch(error => console.error(error));
    toaster.push(message, { placement: 'topCenter' });
    setDataadd({
      Company_Name: '',
      Full_Name: ' ',
      Username: '',
      Category: '',
      Email_Id: '',
      Made_By: 'Shantanu',
      MobileNo: '0',
      Password: '',
      Designation: '',
      UserCode: ''
    });

    setFormValue({
      verifyPassword: ''
    });
    handleCloseUser();
    setImageFile(null);
  };
  return (
    <Modal size="lg" backdrop="static" open={openuser} onClose={handleCloseUser}>
      <Modal.Header>
        <Modal.Title>
          <h5>Add User</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form fluid ref={formRef} onChange={setFormValue} formValue={formValue} model={model}>
          <FlexboxGrid justify="space-between">
            <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>
                  <Stack>
                    <p>Full Name</p>
                    <p style={{ color: 'red' }}>*</p>
                  </Stack>
                </Form.ControlLabel>
                <Input
                  id="Full_Name"
                  name="Full_Name"
                  value={dataadd && dataadd.Full_Name ? dataadd.Full_Name : ''}
                  onChange={value => handleInputChange('Full_Name', value)}
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={4}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>
                  <Stack>
                    <p>Profile Category</p>
                    <p style={{ color: 'red' }}>*</p>
                  </Stack>
                </Form.ControlLabel>
                <InputPicker
                  block
                  id="Category"
                  name="Category"
                  value={dataadd && dataadd.Category ? dataadd.Category : ''}
                  onChange={value => handleInputChange('Category', value)}
                  data={Category}
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={4}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>Designation</Form.ControlLabel>
                <InputPicker
                  block
                  id="Designation"
                  name="Designation"
                  value={dataadd && dataadd.Designation ? dataadd.Designation : ''}
                  onChange={value => handleInputChange('Designation', value)}
                  data={desgindata}
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>
                  <Stack>
                    <p>Username</p>
                    <p style={{ color: 'red' }}>*</p>
                  </Stack>
                </Form.ControlLabel>
                <Input
                  id="Username"
                  name="Username"
                  value={dataadd && dataadd.Username ? dataadd.Username : ''}
                  onChange={value => handleInputChange('Username', value)}
                  // onBlur={() => checkAliasCodeExistence(dataadd.Username)}
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <Form.Group controlId="password-1" style={{ marginBottom: '10px' }}>
                <Form.ControlLabel>
                  <Stack>
                    <p>Password</p>
                    <p style={{ color: 'red' }}>*</p>
                  </Stack>
                </Form.ControlLabel>
                <TextField
                  name="password"
                  type="password"
                  autoComplete="off"
                  id="Password"
                  value={dataadd && dataadd.Password ? dataadd.Password : ''}
                  onChange={value => handleInputChange('Password', value)}
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <Form.Group controlId="password-1">
                <Form.ControlLabel>Confirm Password</Form.ControlLabel>
                <TextField name="verifyPassword" type="password" autoComplete="off" />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <Form.Group controlId="email-1">
                <Form.ControlLabel>Email</Form.ControlLabel>
                <Input
                  id="Email_Id"
                  name="Email_Id"
                  value={dataadd && dataadd.Email_Id ? dataadd.Email_Id : ''}
                  onChange={value => handleInputChange('Email_Id', value)}
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>Mobile Number</Form.ControlLabel>
                <InputNumber
                  id="MobileNo"
                  name="MobileNo"
                  value={dataadd && dataadd.MobileNo ? dataadd.MobileNo : '0'}
                  onChange={value => handleInputChange('MobileNo', value)}
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>
                  <Stack>
                    <p>Company Name</p>
                    <p style={{ color: 'red' }}>*</p>
                  </Stack>
                </Form.ControlLabel>
                <SelectPicker
                  block
                  id="Company_Name"
                  name="Company_Name"
                  value={dataadd && dataadd.Company_Name ? dataadd.Company_Name : ''}
                  onChange={value => handleInputChange('Company_Name', value)}
                  data={data1}
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>Add User Image</Form.ControlLabel>
                <Stack>
                  <Button onClick={handleButtonClick} appearance="default" active>
                    <ImageIcon /> Upload Image
                  </Button>
                  <input
                    type="file"
                    ref={fileInputRef}
                    accept=".jpg, .jpeg"
                    onChange={handleFileChange}
                    style={{ display: 'none' }} // Hide the default file input
                  />
                  {dataadd.UserImage && (
                    <img
                      src={imageFile}
                      alt="Uploaded"
                      style={{ width: '36px', height: '36px', marginLeft: '10px' }}
                    />
                  )}
                </Stack>
              </Form.Group>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Stack justifyContent="flex-end" spacing={10}>
          <Button onClick={handleCloseUser} appearance="default" active>
            Cancel
          </Button>
          <Button onClick={submit} appearance="primary" color="cyan">
            Save
          </Button>
        </Stack>
      </Modal.Footer>
    </Modal>
  );
};

export default UserReg;
